import { TypeEnum } from './rootActions';

export const rootMetaReducer = (reducer: any) => (state: any, action: any) => {
  if (action.type === TypeEnum.Logout) {
    state = undefined;
  }

  return reducer(state, action);
};
